export default __webpack_public_path__ + "locales/uk-UA/SharingPanel.json?hash=3cf9b4ad462b2caa0b90ac1143bf7884";